import React from "react";
import "./InfoCard.css";

export default function InfoCard({ title, description }) {
  return (
    <div className="info-card">
      <div className="info-card-bg" aria-hidden="true" />
      <div className="info-card-content">
        <h3 className="info-card-title">{title}</h3>
        <p className="info-card-desc">{description}</p>
      </div>
    </div>
  );
}
